import { Component, OnInit, Input, Output, EventEmitter, forwardRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';

export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  DOWN_ARROW = 40,
  UP_ARROW = 38,
  SPACE = 32,
  ENTER = 13
}

@Component({
  selector: 'cl-dropdown',
  templateUrl: './cl-dropdown.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ClDropdownComponent),
      multi: true
    }
  ],
  styleUrls: ['./cl-dropdown.component.scss']
})
export class ClDropdownComponent implements OnInit, ControlValueAccessor {
  @Input() items: any = [];
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() tabbable = true;
  @Output() clicked: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  public onChange: any = Function.prototype; // Trascend the onChange event
  public onTouched: any = Function.prototype; // Trascent the onTouch event
  private _value: any; // Private variable for input value
  selectedItem: any;
  selectedItemIdx = 0;
  showMenu = false;
  onFocused = false;

  constructor() { }

  ngOnInit() {
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (!this.disabled) {
      if (this.showMenu) {
        if (event.keyCode === KEY_CODE.DOWN_ARROW) {
          event.preventDefault();
          this.setSelectedItem(true);
        } else if (event.keyCode === KEY_CODE.UP_ARROW) {
          event.preventDefault();
          this.setSelectedItem(false);
        } else if (event.keyCode === KEY_CODE.SPACE || event.keyCode === KEY_CODE.ENTER) {
          event.preventDefault();
          this.onItemSelect(this.selectedItem);
        }
      } else if (this.onFocused) {
        if (event.keyCode === KEY_CODE.DOWN_ARROW && this.items) {
          event.preventDefault();
          this.showMenu = true;
          this.selectedItem = this.items[this.selectedItemIdx];
        }
      }
    }
  }

  setSelectedItem(next: boolean) {
    if (next) {
      if (this.selectedItemIdx < this.items.length - 1) {
        this.selectedItemIdx ++;
        this.selectedItem = this.items[this.selectedItemIdx];
      }
    } else {
      if (this.selectedItemIdx > 0) {
        this.selectedItemIdx --;
        this.selectedItem = this.items[this.selectedItemIdx];
      }
    }
  }

  onClick() {
    this.showMenu = !this.showMenu;
    if (!this.showMenu && !this._value) {
      this.resetSelectedItemIdx();
    } else if (this.showMenu && this._value) {
      this.selectedItemIdx = this.getValueItemIdx();
      this.selectedItem = this.items[this.selectedItemIdx];
    }
  }

  resetSelectedItemIdx() {
    this.selectedItemIdx = 0;
    if (this.items) {
      this.selectedItem = this.items[this.selectedItemIdx];
    }
  }

  onFocus() {
    if (!this.disabled) {
      this.onFocused = true;
    }
  }

  onBlur() {
    if (!this.disabled) {
      this.showMenu = false;
      this.onTouched();
      this.onFocused = false;
      if (!this._value) {
        this.resetSelectedItemIdx();
      } else {
        this.selectedItemIdx = this.getValueItemIdx();
        this.selectedItem = this.items[this.selectedItemIdx];
      }
    }
  }

  getValueItemIdx() {
    let foundIdx = 0;
    if (this._value && this.items && this.items.length > 0) {
      for (let i = 0; i < this.items.length; i++) {
        if (this._value === this.items[i]) {
          foundIdx = i;
          break;
        }
      }
    }

    return foundIdx;
  }

  onItemSelect(v: string) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
      this.change.emit(v);
    }
    this.showMenu = false;
  }

  public validate(c: FormControl) {
    // TODO: add custom validation here
    // return (this._value && this._value.length > 0) ? null : {
    //   required: {
    //     valid: false,
    //   },
    // };
    return null;
  }
  
  get value(): any {
    return this._value;
  }

  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }

  // Required for ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== undefined)  {
      this._value = value;
    }
  }

  // Required for ControlValueAccessor interface
  public registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  // Required for ControlValueAccessor interface
  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
